"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addressGateGuardManifest = void 0;
const generated_1 = require("../generated");
const guards_1 = require("../guards");
/**
 * The addressGate guard restricts the mint to a single
 * address which must match the minting wallet's address.
 */
exports.addressGateGuardManifest = {
    name: 'addressGate',
    serializer: generated_1.getAddressGateSerializer,
    mintParser: guards_1.noopParser,
    routeParser: guards_1.noopParser,
};
//# sourceMappingURL=addressGate.js.map